export default __webpack_public_path__ + "static/media/cog_blue_gradient.dab42342.svg";